<div class="container api-container">
  <!-- Header Section -->
  <div class="p-2">
    <h5 class="h6 mb-2">API {{ transform(usecaseCode) }}</h5>
    <div class="text-secondary">
      <p><strong class="me-2">Server:</strong> {{ server }}</p>
      <p><strong class="me-2">UseCase:</strong> {{ usecaseCode }}</p>
    </div>
  </div>

  <!-- Schema Section -->
  <div class="card border-0 shadow-sm mb-4">
    <div class="card-header border-0">
      <button
        class="btn btn-link text-decoration-none p-0 w-100 text-start"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseSchema"
        aria-expanded="false"
      >
        <div class="d-flex align-items-center justify-content-between pb-2">
          <h5 class="h6 mb-0 text-primary fw-bold">Schema</h5>
          <i class="bi bi-chevron-down text-muted transition-icon"></i>
        </div>
      </button>
    </div>
    <div id="collapseSchema" class="collapse">
      <pre class="bg-light p-3 rounded">{{ api_schema | json }}</pre>
    </div>
  </div>

  <!-- Apis List Header -->
  <div class="d-flex align-items-center my-3 pt-2">
    <h5 class="mb-0">Apis List</h5>
    <span class="badge bg-primary ms-2">{{ endpoints.length }}</span>
  </div>

  <!-- Endpoints -->
  <div class="accordion" id="endpointsAccordion">
    <div
      *ngFor="let endpoint of endpoints; let i = index"
      class="accordion-item border-0 mb-3 shadow-sm"
    >
      <h2 class="accordion-header" [attr.id]="'heading' + i">
        <button
          class="accordion-button collapsed bg-light"
          type="button"
          data-bs-toggle="collapse"
          [attr.data-bs-target]="'#collapse' + i"
        >
          <div class="d-flex align-items-center gap-3 w-100">
            <span class="badge bg-secondary">{{ endpoint.method }}</span>
            <span class="fw-semibold">{{ endpoint.name | uppercase }}</span>

            <span *ngIf="endpoint.custom" class="badge bg-info ms-auto"
              >Custom</span
            >
          </div>
        </button>
      </h2>
      <div
        [id]="'collapse' + i"
        class="accordion-collapse collapse"
        [attr.data-bs-parent]="'#endpointsAccordion'"
      >
        <div class="accordion-body bg-white">
          <p class="mb-3">
            <strong class="me-2">Path:</strong>
            <span class="text-secondary small">{{ endpoint.path }}</span>
          </p>
          <!-- Parameters -->
          <div *ngIf="endpoint.parameters?.length" class="mb-4">
            <h6 class="mb-3">Parameters</h6>
            <div class="table-container mb-3">
              <div class="table-responsive table-scrollable">
                <table
                  class="table table-bordered table-sticky-header"
                  style="vertical-align: middle"
                >
                  <thead>
                    <tr class="border-bottom">
                      <th class="fw-semibold pb-2" style="width: 150px">
                        Name
                      </th>
                      <th class="fw-semibold pb-2">Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let parameter of endpoint.parameters">
                      <td class="fw-semibold">{{ parameter.name }}</td>
                      <td>{{ parameter.description }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Request -->
          <div *ngIf="endpoint.request" class="mb-4">
            <h6 class="mb-3">Request</h6>
            <pre class="bg-light p-3 rounded">{{
              endpoint.request | json
            }}</pre>
          </div>

          <!-- Responses -->
          <div>
            <h6 class="mb-3">Responses</h6>
            <div *ngFor="let response of endpoint.responses" class="mb-3">
              <div class="pb-2">
                <p>
                  <strong class="me-3">Response Code:</strong>
                  <span class="badge bg-success">{{ response.Code }}</span>
                </p>
                <p>
                  <strong class="me-3">Description:</strong>
                  <span class="text-secondary">{{ response.Description }}</span>
                </p>
              </div>
              <pre class="bg-light p-3 rounded">{{
                response.response | json
              }}</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
